/*
 * @Author: liu yang and zhan lin sen
 * @Date: 2020-02-12 13:13:57
 * @LastEditTime : 2020-03-27 15:40:42
 * @LastEditors  : zhan lin sen 
 * @Description: 页面涉及到的地址
 * @FilePath: \trunk\src\utils\config.js
 */
var config = {
    hostApi: 'http://premiumapitest.eastmoney.com/paidvideo2', // 测试环境接口地址
    buyApi: 'http://premiumtest.eastmoney.com/videoCashier/', // 测试环境收银台地址
    getApi: 'http://premiumtest.eastmoney.com/mall#/card' // 测试环境投顾商城地址
}
if (process.env.VUE_APP_VERSION == 'prod') {
    config.hostApi = 'https://premiumdataapi.eastmoney.com/slb-tgapi/paidvideo2'; // 正式环境接口地址
    config.buyApi = 'https://premium.eastmoney.com/videoCashier/'; // 正式环境收银台地址
    config.getApi = 'https://premium.eastmoney.com/mall#/card'; //正式环境投顾商城地址
}

export default config;